import { SeasonStatsToggles, TeamMenuSettings } from '../../types/user';


export const additionalValidTeamMenuProperties: (keyof TeamMenuSettings)[] = [
  'colored',
  'orderBy',
  'showLeft',
  'showAgeCategories',
  'showAgeBirthYear',
  'showContractExpirationYear',
  'hideUnavailablePlayers',
  'doNotShowRoleIndexInfoModalAgain',
];


export const seasonStatsToggleOptions: (keyof SeasonStatsToggles)[] = [
  'aerial',
  'aggressiveness',
  'attacking',
  'defending',
  'distribution',
  'possession',
  'shot_stopping',
  'skillcorner',
  'showTipAndOtip',
  'orderBy',

  'showOverallIndexConfidences',
  'showRoleIndexConfidences',

  'isAcademyTableFilterSectionExpanded',
  'isOwnTeamTableFilterSectionExpanded',
  'showOnlyDomesticLeagues',
  'showOnlySeasonsWith180Minutes',
  'showSeasonsInCareerTable',
];
